<template>
  <div style="padding: 20px;">
    <div
      style="display: flex; justify-content: space-between; flex-wrap: wrap;"
      :class="{ disabled: menus === 'preferences_too_restrictive' }"
    >
      <div class="scale-selector" :class="{ disabled: menus === 'preferences_too_restrictive' }">
        <div class="scale-selector-day" @click="gotoDailyMenu">Jour</div>
        <div class="scale-selector-week active">Semaine</div>
      </div>

      <div class="day-selector" :class="{ disabled: menus === 'preferences_too_restrictive' }">
        <div class="day-selector-arrow" @click="gotoPreviousWeek">
          <font-awesome-icon class="icon" :icon="['fas', 'chevron-left']" />
        </div>

        <div class="day-selector-previous-day">Semaine {{ prevWeekLabel }}</div>
        <div class="day-selector-current-day">Semaine {{ weekNumber }}</div>
        <div class="day-selector-next-day">Semaine {{ nextWeekLabel }}</div>

        <div class="day-selector-arrow" @click="gotoNextWeek">
          <font-awesome-icon class="icon" :icon="['fas', 'chevron-right']" />
        </div>
      </div>

      <div class="scale-selector" style="visibility: hidden;">
        <div class="scale-selector-day">Jour</div>
        <div class="scale-selector-week active">Semaine</div>
      </div>
    </div>

    <div v-if="!loadingPat && patData" class="pat-section">
      <h2 class="pat-title">
        Retrouvez vos actualités locales avec {{ patData.name }}
      </h2>

      <div class="pat-row" v-if="patData.title_1 || patData.text_1">
        <div class="pat-content">
          <a href="/actualites-pat#actulaite-pat-1">{{ patData.title_1 }}</a>
        </div>
      </div>

      <div class="pat-row" v-if="patData.title_2 || patData.text_2">
        <div class="pat-content">
          <a href="/actualites-pat#actulaite-pat-2">{{ patData.title_2 }}</a>
        </div>
      </div>

      <div class="pat-row" v-if="patData.title_3 || patData.text_3">
        <div class="pat-content">
          <a href="/actualites-pat#actulaite-pat-3">{{ patData.title_3 }}</a>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px;">
      <LoaderView v-if="menus == 'loading' || menus == null"></LoaderView>

      <div v-else-if="menus == 'error'">
        <font-awesome-icon class="icon" :icon="['fas', 'exclamation-triangle']" />
      </div>

      <div v-else-if="menus == 'consumer_profil_not_available'">
        Vous n'avez pas encore rempli votre profil de meilleur mangeur
      </div>

      <div v-else-if="menus == 'preferences_too_restrictive'">
        Mes critères de composition des menus sont trop restrictifs et ne permettent pas à Mes Meilleurs Menus de me
        proposer un programme de menus : est-il possible de simplifier
        <router-link to="/mes-preferences" style="font-weight:bold; color:#436f0e;">
          Mes Préférences
        </router-link>
        ?<br />
        (Temps maximum pour cuisiner, trop d'ingrédients exclus ...)
      </div>

      <div v-else-if="menus == 'not_yet_available'">
        Nous n'avons pas encore décidé de votre menu pour cette semaine
      </div>

      <div v-else>
        <div v-for="dailyMenu of menus" :key="dailyMenu.date" class="menu-container">
          <div class="day">{{ humanizeDate(dailyMenu.date) }}</div>

          <div class="menu-grid">
            <div
              v-for="(card, index) in getDisplayCardsFromDailyMenu(dailyMenu)"
              :key="`${dailyMenu.date}-${card.type}-${card.meal || card.item?.id || index}`"
              class="menu-grid-item"
            >
              <MenuItemCard
                v-if="card.type === 'item'"
                :item="card.item"
                :date="dailyMenu.date"
                :meal-badge-type="card.mealBadgeType"
                @update="updateMenuItem"
              />

              <div v-else-if="card.type === 'outside'" class="outside-card">
                <img :src="burgerImage" alt="Repas à l'extérieur" class="outside-card-image" />

                <div class="outside-card-meal">
                  {{ card.label }}
                </div>

                <div class="outside-card-name">
                  Repas à l'extérieur
                </div>

                <div class="outside-card-spacer"></div>

                <div class="outside-card-bottom-bar">
                  <div class="outside-card-icon-circle">
                    <font-awesome-icon class="icon" :icon="['fas', 'utensils']" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-cards">
      <MyPdf />
      <MyLikedDishes />

      <div class="card green">
        <div class="form-title">Mes apports nutritionnels</div>
        <div class="card light-green clickable" @click="gotoApports">
          <div class="liked-dish-name">Voir mes apports nutritionnels</div>
        </div>
        <div class="card light-green mt-4">
          <a href="/couverture-des-besoins" class="liked-dish-name">Couverture des besoins</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import MyLikedDishes from "@/views/MyLikedDishes.vue";
import MyPdf from "@/views/MyPdf.vue";
import MenuItemCard from "@/components/MenuItemCard.vue";

export default {
  name: "MyMenusWeek",
  components: {
    LoaderView,
    MyLikedDishes,
    MenuItemCard,
    MyPdf,
  },

  data() {
    return {
      year: new Date().getFullYear(),
      weekNumber: this.getCurrentWeekNumber(),
      baseWeekNumber: null,
      menus: null,
      nextWeekMenusCache: [],
      patData: null,
      loadingPat: true,
      burgerImage: "/images/repas-exterieur.jpg",
    };
  },

  computed: {
    weeksInYear() {
      const y = this.year;
      return this.getCurrentWeekNumber(new Date(y, 11, 28));
    },
    prevWeekLabel() {
      return this.weekNumber === 1 ? this.weeksInYear : this.weekNumber - 1;
    },
    nextWeekLabel() {
      return this.weekNumber === this.weeksInYear ? 1 : this.weekNumber + 1;
    },
  },

  mounted() {
    this.baseWeekNumber = this.weekNumber;
    this.menus = "loading";
    this.checkCurrentWeek();
    this.fetchPat();
  },

  methods: {
    gotoPreviousWeek() {
      if (this.menus === "preferences_too_restrictive") return;

      const last = this.weeksInYear;
      this.weekNumber = this.weekNumber === 1 ? last : this.weekNumber - 1;

      this.loadMenus(this.weekNumber);
    },

    gotoNextWeek() {
      if (this.menus === "preferences_too_restrictive") return;

      const last = this.weeksInYear;
      this.weekNumber = this.weekNumber === last ? 1 : this.weekNumber + 1;

      this.loadMenus(this.weekNumber);
    },

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    normalizeWeekNumber(weekNumber) {
      const last = this.weeksInYear;

      if (weekNumber < 1) {
        return last;
      }

      if (weekNumber > last) {
        return 1;
      }

      return weekNumber;
    },

    async fetchWeekMenus(weekNumber) {
      const normalizedWeekNumber = this.normalizeWeekNumber(weekNumber);
      const response = await api.get(`my-menus/${normalizedWeekNumber}/`);
      return response.data;
    },

    async loadMenus(weekNumber) {
      this.menus = "loading";
      this.nextWeekMenusCache = [];

      try {
        const normalizedWeekNumber = this.normalizeWeekNumber(weekNumber);
        const currentWeekMenus = await this.fetchWeekMenus(normalizedWeekNumber);

        if (normalizedWeekNumber === this.weekNumber) {
          this.menus = currentWeekMenus;
        }

        // Fetch next week separately — a 404 here is normal (menus not yet generated)
        try {
          const nextWeekMenus = await this.fetchWeekMenus(normalizedWeekNumber + 1);
          this.nextWeekMenusCache = Array.isArray(nextWeekMenus) ? nextWeekMenus : [];
        } catch (_nextError) {
          this.nextWeekMenusCache = [];
        }
      } catch (error) {
        if (this.normalizeWeekNumber(weekNumber) === this.weekNumber) {
          if (error.response && error.response.status === 404) {
            this.menus = "not_yet_available";
          } else {
            this.menus = "error";
          }
        }
      }
    },

    async checkCurrentWeek() {
      // La semaine suivante peut ne pas être encore générée (job du lundi) : on n'exige que celle-ci.
      try {
        const normalizedWeek = this.normalizeWeekNumber(this.baseWeekNumber);

        const response = await api.get(`my-menus/${normalizedWeek}/`).catch((error) => {
          if (error.response && error.response.status === 404) {
            return { _error404: true };
          }
          throw error;
        });

        if (response._error404) {
          this.menus = "preferences_too_restrictive";
          return;
        }

        const weekMenus = response.data;

        if (!Array.isArray(weekMenus) || weekMenus.length < 7) {
          this.menus = "preferences_too_restrictive";
          return;
        }

        this.loadMenus(this.weekNumber);
      } catch (e) {
        console.error("Erreur checkCurrentWeek :", e);
      }
    },

    getCurrentWeekNumber(date = new Date()) {
      const target = new Date(date.valueOf());
      target.setDate(target.getDate() + 3 - ((target.getDay() + 6) % 7));

      const firstThursday = new Date(target.getFullYear(), 0, 4);
      firstThursday.setDate(
        firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7)
      );

      return 1 + Math.round(((target - firstThursday) / 86400000 - 3) / 7);
    },

    humanizeDate(isoDate) {
      const date = new Date(isoDate);
      return this.capitalizeFirstLetter(
        date.toLocaleDateString("fr-FR", {
          weekday: "long",
          day: "numeric",
          month: "long",
        })
      );
    },

    gotoDailyMenu() {
      if (this.menus === "preferences_too_restrictive") return;
      this.$router.push({ name: "my-menu" });
    },

    getDailyMenuByDate(date) {
      if (Array.isArray(this.menus)) {
        const currentWeekDailyMenu = this.menus.find((menu) => menu.date === date);
        if (currentWeekDailyMenu) {
          return currentWeekDailyMenu;
        }
      }

      if (Array.isArray(this.nextWeekMenusCache)) {
        const nextWeekDailyMenu = this.nextWeekMenusCache.find((menu) => menu.date === date);
        if (nextWeekDailyMenu) {
          return nextWeekDailyMenu;
        }
      }

      return null;
    },

    getNextDate(dateString) {
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1);
      return date.toISOString().split("T")[0];
    },

    getMealBadgeTypeForItem(dailyMenu, item) {
      if (!dailyMenu || !item) {
        return null;
      }

      if (item.meal_origin_type === "leftovers") {
        return "leftovers";
      }

      const nextDate = this.getNextDate(dailyMenu.date);
      const nextDailyMenu = this.getDailyMenuByDate(nextDate);

      if (["diner_starter", "diner_main"].includes(item.dish_type)) {
        if (nextDailyMenu && nextDailyMenu.lunch_origin_type === "leftovers") {
          return "parent_leftovers";
        }
      }

      if (["lunch_starter", "lunch_main"].includes(item.dish_type)) {
        if (dailyMenu.dinner_origin_type === "leftovers") {
          return "parent_leftovers";
        }
      }

      return null;
    },

    getDisplayCardsFromDailyMenu(dailyMenu) {
      const cards = [];
      const items = [...dailyMenu.items];

      const breakfast = items.find((item) => item.dish_type === "breakfast");
      const lunchMain = items.find((item) => item.dish_type === "lunch_main");
      const snack = items.find((item) => item.dish_type === "snack");
      const dinnerMain = items.find((item) => item.dish_type === "diner_main");

      if (breakfast) {
        cards.push({
          type: "item",
          item: breakfast,
          mealBadgeType: this.getMealBadgeTypeForItem(dailyMenu, breakfast),
        });
      }

      if (dailyMenu.lunch_origin_type === "outside") {
        cards.push({ type: "outside", meal: "lunch", label: "Déjeuner" });
      } else if (lunchMain) {
        cards.push({
          type: "item",
          item: lunchMain,
          mealBadgeType: this.getMealBadgeTypeForItem(dailyMenu, lunchMain),
        });
      }

      if (snack) {
        cards.push({
          type: "item",
          item: snack,
          mealBadgeType: this.getMealBadgeTypeForItem(dailyMenu, snack),
        });
      }

      if (dailyMenu.dinner_origin_type === "outside") {
        cards.push({ type: "outside", meal: "dinner", label: "Dîner" });
      } else if (dinnerMain) {
        cards.push({
          type: "item",
          item: dinnerMain,
          mealBadgeType: this.getMealBadgeTypeForItem(dailyMenu, dinnerMain),
        });
      }

      return cards;
    },

    updateMenuItem(item) {
      this.menus = this.menus.map((dailyMenu) => {
        dailyMenu.items = dailyMenu.items.map((i) =>
          i.id == item.id ? item : i
        );
        return dailyMenu;
      });

      this.nextWeekMenusCache = this.nextWeekMenusCache.map((dailyMenu) => {
        dailyMenu.items = dailyMenu.items.map((i) =>
          i.id == item.id ? item : i
        );
        return dailyMenu;
      });
    },

    gotoApports() {
      this.$router.push({ name: "apports" });
    },

    async fetchPat() {
      try {
        const response = await api.get("/my-pat/");
        if (response.data && response.data.pat) {
          this.patData = response.data.pat;
        } else {
          this.patData = null;
        }
      } catch (e) {
        this.patData = null;
      } finally {
        this.loadingPat = false;
      }
    },

    fullImage(url) {
      if (!url) return null;
      return `https://backend-v2.mmmenus.fr${url}`;
    },
  },
};
</script>

<style scoped>
.day-selector {
  display: flex;
  justify-content: center;
  gap: 20px;
  align-items: center;
  margin: 0 20px;
}

.day-selector-arrow {
  cursor: pointer;
  background: #436f0e;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.day-selector-previous-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.day-selector-current-day {
  font-size: 30px;
  font-family: "Amanise";
  font-weight: 500;
  color: #436f0e;
}

.day-selector-next-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
}

.day {
  font-size: 30px;
  font-family: "Amanise";
  font-weight: 500;
  color: #436f0e;
}

@media (max-width: 768px) {
  .day {
    text-align: center;
  }
}

.menu-container {
  margin-bottom: 40px;
  flex-direction: column;
}

.menu-grid {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.menu-grid-item {
  display: flex;
}

@media (max-width: 768px) {
  .menu-grid {
    justify-content: center;
  }
}

.menu-item {
  background: white;
  padding: 20px;
  margin: 10px;
  width: 200px;
  min-width: 150px;
  height: 100%;
}

.menu-item-image {
  width: 100%;
  border-radius: 10px;
}

.menu-item-meal {
  font-size: 20px;
  font-weight: 800;
  color: #436f0e;
}

.menu-item-name {
  font-size: 15px;
}

.menu-item-bottom-bar {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 10px;
}

.scale-selector {
  display: flex;
  justify-content: center;
}

.scale-selector-day {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-right: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-day.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-day:hover {
  background: #85a063;
  color: white;
  border: none;
}

.scale-selector-week {
  font-size: 20px;
  font-family: "Amanise";
  font-weight: 500;
  color: #85a063;
  cursor: pointer;
  border: 1px solid #436f0e;
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  background: white;
}

.scale-selector-week.active {
  background: #436f0e;
  color: white;
  border: none;
}

.scale-selector-week:hover {
  background: #85a063;
  color: white;
  border: none;
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}

.bottom-cards {
  margin-top: 50px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.bottom-cards>* {
  flex: 1 1 300px;
  max-width: 100%;
}

.disabled {
  opacity: 0.4;
  pointer-events: none;
}

.pat-section {
  margin-top: 30px;
  padding: 20px 0;
}

.pat-title {
  font-size: 26px;
  margin-bottom: 25px;
  font-weight: bold;
}

.pat-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.pat-img {
  width: 150px;
  height: auto;
  border-radius: 6px;
  object-fit: cover;
}

.pat-content h3 {
  margin: 0 0 10px 0;
  font-weight: bold;
}

.pat-content p {
  margin: 0 0 10px 0;
  white-space: pre-line;
}

.pat-link {
  color: #8abd37;
  font-weight: bold;
  text-decoration: none;
}

.pat-link:hover {
  text-decoration: underline;
}

.outside-card {
  background: white;
  padding: 20px;
  margin: 10px;
  width: 200px;
  min-width: 150px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
}

.outside-card-image {
  width: 100%;
  object-fit: cover;
}

.outside-card-meal {
  font-size: 20px;
  font-weight: 800;
  color: #436f0e;
  margin-top: 12px;
}

.outside-card-name {
  font-size: 15px;
  margin-top: 8px;
}

.outside-card-spacer {
  flex: 1;
  min-height: 20px;
}

.outside-card-bottom-bar {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 10px;
}

.outside-card-icon-circle {
  cursor: default;
  background: #8abd37;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
</style>